import { decode } from 'base-64';
import {
  getAnalytics,
  setUserId as fSetUserId,
  setUserProperties as fSetUserProperties,
  logEvent as fLogEvent,
  CustomParams,
} from 'firebase/analytics';
import Config from '@betty/toolkit/config';
import { logError } from '@betty/toolkit/logging';
import { initializeApp } from 'firebase/app';

export const initAnalytics = () => {
  try {
    if (!Config.FIREBASE_CONFIG_WEB) {
      return;
    }

    const config = JSON.parse(decode(Config.FIREBASE_CONFIG_WEB ?? ''));

    const app = initializeApp(config);
    const analytics = getAnalytics(app);
    let userProperties: CustomParams = {};

    return {
      setUserId: (id: string) => fSetUserId(analytics, id),
      setUserProperties: (properties: CustomParams) => {
        userProperties = { ...userProperties, ...properties };

        fSetUserProperties(analytics, userProperties);
      },
      resetUserProperties: () => {
        userProperties = {};

        fSetUserProperties(analytics, userProperties);
      },
      logEvent: (name: string, params?: CustomParams) => {
        fLogEvent(analytics, name, { ...userProperties, ...params });
      },
    };
  } catch (e) {
    logError('Firebase init error', e);
  }
};
